var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEntSaud({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41603 2C7.10639 2 7.66603 2.55965 7.66603 3.25V4.50001H8.91604C9.60639 4.50001 10.166 5.05965 10.166 5.75001C10.166 6.44037 9.60639 7.00002 8.91604 7.00002H7.66603V8.25002C7.66603 8.94038 7.10639 9.50002 6.41603 9.50002C5.72567 9.50002 5.16602 8.94038 5.16602 8.25002V7.00002H3.91602C3.22566 7.00002 2.66602 6.44037 2.66602 5.75001C2.66602 5.05965 3.22566 4.50001 3.91602 4.50001H5.16602V3.25C5.16602 2.55965 5.72567 2 6.41603 2ZM6.41603 14.5C7.10639 14.5 7.66603 15.0597 7.66603 15.75V17H8.91604C9.60639 17 10.166 17.5597 10.166 18.25C10.166 18.9404 9.60639 19.5001 8.91604 19.5001H7.66603V20.7501C7.66603 21.4404 7.10639 22.0001 6.41603 22.0001C5.72567 22.0001 5.16602 21.4404 5.16602 20.7501V19.5001H3.91602C3.22566 19.5001 2.66602 18.9404 2.66602 18.25C2.66602 17.5597 3.22566 17 3.91602 17H5.16602V15.75C5.16602 15.0597 5.72567 14.5 6.41603 14.5Z",
    fill: "#FA532E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.166 2C15.7332 2 16.2292 2.38185 16.3744 2.93014L17.8484 8.49868L22.0407 10.9173C22.4276 11.1405 22.666 11.5533 22.666 12C22.666 12.4468 22.4276 12.8595 22.0407 13.0828L17.8484 15.5014L16.3744 21.0699C16.2292 21.6182 15.7332 22.0001 15.166 22.0001C14.5988 22.0001 14.1027 21.6182 13.9576 21.0699L12.4836 15.5014L8.29137 13.0828C7.90443 12.8595 7.66603 12.4468 7.66603 12C7.66603 11.5533 7.90443 11.1405 8.29137 10.9173L12.4836 8.49869L13.9576 2.93014C14.1027 2.38185 14.5988 2 15.166 2Z",
    fill: "#FA532E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEntSaud);
export default __webpack_public_path__ + "static/media/ent-saud.cb22cdcba51e20d3410e25a0201b596a.svg";
export { ForwardRef as ReactComponent };